import styled from "@emotion/styled";

export const Container = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background: rgba(255, 255, 255, 0.5);
`;
export const LoadingElement = styled.div`
  width: 10vw;
`;
